import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Icon,
  FormHelperText,
  HStack,
} from '@wegroup/design-system';
import { sanitize } from 'dompurify';
import React from 'react';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Inputs } from '../../../../types/Enums';
import { getFlowsDataTestId } from '../../../../utils/testUtils';
import { FormValues } from './NaceCodeModal';

interface Props {
  register: UseFormRegister<FormValues>;
  setValue: UseFormSetValue<FormValues>;
}

const NaceCodeSearchInput: React.FC<React.PropsWithChildren<Props>> = ({
  register,
  setValue,
}) => {
  const { t } = useTranslation();

  return (
    <FormControl>
      <FormLabel htmlFor="searchQuery">
        {t('FLOWS_COMPANY-SCAN_NACE-INPUT_SEARCH-INPUT_LABEL')}
      </FormLabel>
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <Icon name="GeneralActionsSearch" color="gray.200" />
        </InputLeftElement>
        <Input
          {...register('searchQuery')}
          placeholder={t(
            'FLOWS_COMPANY-SCAN_NACE-INPUT_SEARCH-INPUT_PLACEHOLDER',
          )}
          data-test-id={getFlowsDataTestId(
            Inputs.NACE_CODE,
            'NACE-SEARCH-INPUT',
          )}
        />
        <InputRightElement
          cursor="pointer"
          onClick={() => setValue('searchQuery', '')}
        >
          <Icon name="GeneralActionsCloseOrRemove" />
        </InputRightElement>
      </InputGroup>
      <HStack>
        <Icon name="GeneralStatusInfo" color="text.gray" />
        <FormHelperText
          color="text.gray"
          dangerouslySetInnerHTML={{
            __html: sanitize(
              t('FLOWS_COMPANY-SCAN_NACE-INPUT_SEARCH-INPUT_HELP-TEXT'),
              { ADD_ATTR: ['target'] },
            ),
          }}
        />
      </HStack>
    </FormControl>
  );
};

export default NaceCodeSearchInput;
